<template lang="html">
<div class="map-legend" :class="{ showing: value }">

    <div
        id="map-legend-button"
        class="mapboxgl-ctrl mapboxgl-ctrl-group map-legend-control"
        v-bind:style="{ top: topStyle }"
        @click="show(!value)">
        <v-tooltip right>
            <button type="button" slot="activator">
                <v-icon class="mbgl-color">info</v-icon>
            </button>
            <span>Map legend</span>
        </v-tooltip>
    </div>

    <div
        id="map-legend-popup"
        class="legend-items mapboxgl-ctrl mapboxgl-ctrl-group mbgl-color"
        v-bind:style="{ top: topStyle }"
        v-if="value"
        @click="show(false)">
        <v-list dense light subheader>
            <v-subheader>
                <span class="selection-subhead mbgl-color">
                    Map legend
                </span>
            </v-subheader>
            <v-list-tile
                class="list-item"
                avatar
                v-for="item in items"
                :key="item.name"
                >

                <div class="icon-wrap">
                    <div class="map-circle" :style="getCircleStyle(item)"></div>
                </div>

                <v-list-tile-content>
                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </div>

</div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
        value: Boolean,
    },
    computed: {
        topStyle() {
            if (this.$router.currentRoute.path === '/watershed') {
                return '200px';
            }
            return '160px';
        },
    },
    methods: {
        /**
         * build style object for legend items
         * @param  {Object} item item configuration
         * @return {Object}      vue style object
         */
        getCircleStyle(item) {
            const defaultStyle = {
                color: '#ccc',
                borderColor: '#fff',
            };
            const mergedStyle = Object.assign({}, defaultStyle, item);
            return {
                'background-color': mergedStyle.color,
                'border-color': mergedStyle.borderColor,
            };
        },
        /**
         * change visible state of the map legend
         * hides by default
         * @param  {Boolean} [on=false] true for visible
         */
        show(on = false) {
            this.$emit('input', on);
        },
    },
};
</script>

<style lang="scss">
.map-legend {
    > div {
        position: absolute;
        left: 10px;
    }

    .mbgl-color {
        color: #333;
    }

    .map-legend-control {
        button {
            height: 30px;
            width: 30px;
        }
    }

    .legend-items {
        margin-left: -4px;
        margin-top: -4px;

        .selection-subhead {
            margin-left: 30px;
        }

        .icon-wrap {
            margin-right: 1rem;
        }

        .map-circle {
            height: 1.25rem;
            width: 1.25rem;
            background: #ccc;
            border-radius: 100%;
            border: 2px solid #fff;
            box-shadow: 1px 1px 3px #999;
        }
    }

    &.showing {
        z-index: 2;
        .map-legend-control {
            z-index: 3;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MapLegend.vue